import React from 'react';
import { DescriptionTemplate } from 'themes/modules/product/pages';

class Description extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <DescriptionTemplate {...this.props} />;
	}
}

export default Description;



// WEBPACK FOOTER //
// ./src/modules/product/pages/Description.jsx